module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30 w-900"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户组名称",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "父级用户组",
      "prop": "pid"
    }
  }, [_c('el-select', {
    staticClass: "w-200",
    attrs: {
      "placeholder": "父级用户组"
    },
    model: {
      value: (_vm.form.pid),
      callback: function($$v) {
        _vm.$set(_vm.form, "pid", $$v)
      },
      expression: "form.pid"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.title,
        "value": item.group_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    staticClass: "w-200",
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "备注"
    },
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", $$v)
      },
      expression: "form.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权限分配"
    }
  }, [_c('div', {
    staticClass: "bor-gray h-400 ovf-y-auto bor-ra-5 bg-wh"
  }, _vm._l((_vm.nodes), function(item) {
    return _c('div', [_c('div', {
      staticClass: "bor-b-ccc bg-gra p-l-10 p-r-10"
    }, [_c('el-checkbox', {
      on: {
        "change": function($event) {
          return _vm.selectProjectRule(item)
        }
      },
      model: {
        value: (item.check),
        callback: function($$v) {
          _vm.$set(item, "check", $$v)
        },
        expression: "item.check"
      }
    }, [_vm._v(_vm._s(item.else))])], 1), _vm._v(" "), _vm._l((item.child), function(childItem) {
      return _c('div', [_c('div', {
        staticClass: "p-l-20 bor-b-ccc"
      }, [_c('el-checkbox', {
        on: {
          "change": function($event) {
            return _vm.selectModuleRule(childItem, item, childItem.child)
          }
        },
        model: {
          value: (childItem.check),
          callback: function($$v) {
            _vm.$set(childItem, "check", $$v)
          },
          expression: "childItem.check"
        }
      }, [_vm._v(_vm._s(childItem.else))])], 1), _vm._v(" "), _c('div', {
        staticClass: "p-l-40 bor-b-ccc bg-gra"
      }, _vm._l((childItem.child), function(grandChildItem) {
        return _c('el-checkbox', {
          on: {
            "change": function($event) {
              return _vm.selectActionRule(grandChildItem, childItem, item)
            }
          },
          model: {
            value: (grandChildItem.check),
            callback: function($$v) {
              _vm.$set(grandChildItem, "check", $$v)
            },
            expression: "grandChildItem.check"
          }
        }, [_vm._v(_vm._s(grandChildItem.else))])
      }), 1)])
    })], 2)
  }), 0)]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add('form')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38da68f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrative/structures/groups/add.vue
// module id = 1830
// module chunks = 2